import { render, staticRenderFns } from "./TablesOrderingMenu.vue?vue&type=template&id=755e4bf7&scoped=true&"
import script from "./TablesOrderingMenu.vue?vue&type=script&lang=js&"
export * from "./TablesOrderingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e4bf7",
  null
  
)

export default component.exports